<template>
  <a-checkbox @change="change" v-bind="$attrs" :checked="value">
    <slot>
      {{lebel}}
    </slot>
  </a-checkbox>
</template>

<script>
  export default {
    name: 'ptCheckbox',
    props:{
      lebel:{
        type:String,
      },
      value:{

      }
    },
    data() {
      return {}
    },
    mounted() {

    },
    methods: {
      change(e){
        this.$emit('input',e.target.checked)
        this.$emit('change',e.target.checked)
      }
    }
  }
</script>

<style scoped lang="less">

</style>